import Swiper from "swiper";

export function mobileSliderInit(
    selector = ".swiper",
    settings = {
        media: 768,
        sliderOptions: {},
    }
) {
    let slider = null;

    const mediaQuery = settings.media;
    const options = settings.sliderOptions;

    window.addEventListener("load", sliderSwitch);
    window.addEventListener("resize", sliderSwitch);

    function sliderSwitch() {
        const viewportWidth = document.documentElement.clientWidth;

        if (viewportWidth <= mediaQuery) {
            sliderInit();
        } else {
            sliderDestroy();
        }
    }

    function sliderInit() {
        if (!slider) {
            slider = new Swiper(selector, options);
        }
    }

    function sliderDestroy() {
        if (slider) {
            slider.destroy();
            slider = null;
        }
    }
}
